import React from 'react'
import Image from 'next/image'

import { Layout, Section, Column, Row } from '@/components/layout'
import IntegrationsTabs from '@/components/sections/IntegrationsTabs/IntegrationsTabs'
import FeaturesFooter from '@/components/sections/FeaturesFooter'
import heroImg from '@/assets/integration-support/hero.png'

import styles from './integration-support.module.scss'

const pageId = 'integrationSupport'

export default function IntegrationSupport() {
  return (
    <Layout.Content>
      <Section wrapperClassName={styles.heroBackground}>
        <Row center>
          <Column>
            <h1 className="c-background">Connect Seamlessly With Business Software</h1>
          </Column>
          <Column>
            <Image alt="" className={styles.hero} src={heroImg} />
          </Column>
        </Row>
      </Section>
      <Section bgSecondary>
        <Column textCenter>
          <h2>Do More With Neat Integrations</h2>
          <div className={styles.divider} />
          <p>Extend the capabilities of Neat by automating data transfer to your accounting, email, or tax preparation software. Send and map expenses to QuickBooks, instantly turn business cards into email contacts, and export tax information in just a few clicks. Select a product below to get more information on connecting it to Neat.</p>
        </Column>
      </Section>
      <IntegrationsTabs />
      <FeaturesFooter sectionProps={{ className: styles.footerSection }} />
    </Layout.Content>
  )
}

IntegrationSupport.layoutProps = {
  pageId,
}
